import React from 'react';
import { cn } from '../../../ui/cn';
import { WIDGET_CARD_CLASS } from './widgetAnalyticsUi';

const DashboardWidgetShell = ({
  title,
  subtitle,
  children,
  className = '',
  footer,
  fillHeight = false,
  variant = 'default'
}) => (
  <div
    className={cn(
      WIDGET_CARD_CLASS,
      variant === 'chart' ? 'p-6' : 'p-5',
      fillHeight && 'h-full',
      className
    )}
  >
    {(title || subtitle) && (
      <div className={cn('mb-4', variant === 'chart' && 'mb-4')}>
        {title && <h3 className="text-sm font-medium text-gray-900 font-sans">{title}</h3>}
        {subtitle && <p className="mt-1 text-xs text-gray-400 font-sans">{subtitle}</p>}
      </div>
    )}
    <div className="flex-1 min-h-0">{children}</div>
    {footer && <div className="mt-4 pt-3 border-t border-gray-100">{footer}</div>}
  </div>
);

export default DashboardWidgetShell;
